module.exports = __webpack_public_path__ + "img/back-5.a67b9008.png";